import { useEffect, useRef, useState } from "react"

export function useTextWidth(text: string) {
  const [width, setWidth] = useState(0)
  const spanRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (!spanRef.current) return

    // Calculate width after fonts are loaded
    document.fonts.ready.then(() => {
      setWidth(spanRef.current?.offsetWidth || 0)
    })

    // Add resize observer for dynamic updates
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target instanceof HTMLElement) {
          setWidth(entry.target.offsetWidth)
        }
      }
    })

    resizeObserver.observe(spanRef.current)

    return () => resizeObserver.disconnect()
  }, [text])

  return { width, ref: spanRef }
}
